import React from 'react';
import { ValueChangedForFieldFunc } from '../../formeditor-types';
import '../../styles/SignatureModal.scss';
import SignatureV2Modal from './SignatureV2Modal';

export interface SignatureModalProps {
  w?: number;
  h?: number;
  name?: string;
  value?: string;
  foregroundColor?: TypeMePlease;
  valueUpdated?: ValueChangedForFieldFunc;
  onClose?: AnyFunc;
  backgroundCropDimensions?: TypeMePlease;
  sasToken?: TypeMePlease;
  fileUrls?: TypeMePlease;
  signingMethod?: number;
  color?: TypeMePlease;
  fieldId?: string;
  formId?: string;
  rowNumber: number;
}

export default function SignatureModal(props: SignatureModalProps) {
  return (
    <SignatureV2Modal
      name={props.name}
      w={props.w}
      h={props.h}
      color={props.color}
      value={props.value}
      valueUpdated={props.valueUpdated}
      formId={props.formId}
      fieldId={props.fieldId}
      signingMethod={props.signingMethod}
      backgroundCropDimensions={props.backgroundCropDimensions}
      onClose={props.onClose}
      rowNumber={props.rowNumber}
    />
  );
}
